import React from 'react';
import {Button, Spinner} from 'reactstrap';

const FinishSetup = ({ institutionObj, loading, updateInstitution, userObj }) => {
    return (
        <div>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <h4 className="bold-text">Created Institution Details</h4>
                    <dl className="row">
                        <dt className="col-sm-4">Name</dt>
                        <dd className="col-sm-8">
                        <p>{institutionObj?.name}</p>
                        </dd>
                    
                        <dt className="col-sm-4">Fep Code</dt>
                        <dd className="col-sm-8">
                        <p>{institutionObj?.fepCode}</p>
                        </dd>

                        <dt className="col-sm-4">Domain Code</dt>
                        <dd className="col-sm-8">
                        <p>{institutionObj?.domainCode}</p>
                        </dd>

                        <dt className="col-sm-4">Institution Phone No.</dt>
                        <dd className="col-sm-8">
                        <p>{institutionObj?.subscriberId}</p>
                        </dd>
                    </dl> 
                </div>
                <br />
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <h4 className="bold-text">Created Admin User Details</h4>
                    <dl className="row">
                        <dt className="col-sm-4">Firstname</dt>
                        <dd className="col-sm-8">
                            <p>{userObj?.first_name}</p>
                        </dd>

                        <dt className="col-sm-4">Lastname</dt>
                        <dd className="col-sm-8">
                            <p>{userObj?.last_name}</p>
                        </dd>

                        <dt className="col-sm-4">Email</dt>
                        <dd className="col-sm-8">
                            <p>{userObj?.email}</p>
                        </dd>

                        <dt className="col-sm-4">Mobile number</dt>
                        <dd className="col-sm-8">
                            <p>{userObj?.phone_number}</p>
                        </dd>
                    </dl>
                </div>
            </div>
            <br/>
            <div style={{display: 'flex', justifyContent: 'center'}} className="row">
                <Button color="primary" id="submit-btn" type="submit" onClick={updateInstitution} style={{margin: '0 auto'}}>
                    {loading ? (
                    <span>
                    <Spinner size="sm" color="default" />{" "}
                    </span>
                ) : ''}
                    Complete Setup
                </Button> 
            </div>
        </div>
    );
};

export default FinishSetup;